import './SignInPage.css';
import {Button, Input, message} from "antd";
import { EyeInvisibleOutlined, EyeTwoTone, SafetyCertificateOutlined, UserOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { AppUser } from "../../types/AppUser";
import { getApiUrl } from '../../config/api';

export const SignInPage = () => {
    const [account, setAccount] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [isLogedIn, setIsLogedIn] = useState<boolean>(false);
    const [loggedInUser, setLoggedInUser] = useState<AppUser | null>(null);

    useEffect(() => {
        const storedUser = localStorage.getItem("DORS_USER");

        if (storedUser) {
            const parsedUser: AppUser = JSON.parse(storedUser);
            setLoggedInUser(parsedUser);
            setIsLogedIn(true);
        }
    }, []);

    useEffect(() => {
        console.log("loggedInUser", loggedInUser);
    }, [loggedInUser]);

    const handleSignIn = async () => {
        const isEmail = account.includes('@');

        const requestBody = {
            EmailAddress: isEmail ? account : null,
            PhoneNumber: isEmail ? null : account,
            Password: password
        };

        try {
            const response = await fetch(getApiUrl("/api/AppAccount/Login"), {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestBody),
            });

            const jsonResponse = await response.json();

            if (!response.ok) {
                message.error(`${jsonResponse.message} Failed to sign in. Please try again.`);
                return;
            }

            const userData: AppUser = {
                Aid: jsonResponse.Aid,
                FirstName: jsonResponse.FirstName,
                AuthorityLv: jsonResponse.AuthorityLv,
                ContractNo: jsonResponse.ContractNo
            };

            localStorage.setItem("DORS_USER", JSON.stringify(userData));
            setLoggedInUser(userData);
            setIsLogedIn(true);

        } catch (error) {
            console.error("Error during login:", error);
            message.error("Network error. Please try again.");
        }
        setAccount("");
        setPassword("");
    };

    const handleSignOut = () => {
        localStorage.removeItem("DORS_USER");
        setLoggedInUser(null);
        setIsLogedIn(false);
    };

    return (
        <div className="sign_in_page">
            { !isLogedIn ? (<div className="display_sign_in">
                <div className="sign_in_title">Sign in to check DDR</div>
                <div className="account_input_box">
                    <Input size="large"
                           placeholder="Email address or phone number"
                           prefix={<UserOutlined />}
                           value={account}
                           onChange={(e) => setAccount(e.target.value)}
                    />
                </div>
                <div className="pwd_input_box">
                    <Input.Password
                        size="large"
                        placeholder="Password"
                        prefix={<SafetyCertificateOutlined />}
                        iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>
                <Button className="sign_in_btn" type="primary" size="large"
                        style={{backgroundColor: '#002E57'}} shape="round" onClick={handleSignIn} >
                    Sign In
                </Button>
            </div>) :
            (<div className="display_sign_out">
                <div className="sign_out_title">{`Hi ${loggedInUser?.FirstName}!`}</div>
                <Button className="sign_in_btn" type="primary" size="large"
                        style={{backgroundColor: '#a0784d'}} shape="round" onClick={handleSignOut} >
                    Sign Out
                </Button>
            </div>)}
        </div>
    );
};
